import { SignatureRequest } from "@wingspanhq/wingspan-api-sdk";

import { ContextItem, RequirementTableItemData } from "../../../../types";

export const getSignatureRequirementName = (
  requirement: RequirementTableItemData,
  context: ContextItem,
  signatureRequest: SignatureRequest | undefined
) => {
  if (requirement.name) {
    return requirement.name;
  }

  if (!signatureRequest?.title) {
    return "--";
  }

  return signatureRequest.title;
};
